(function() {
  if (window.JuneWallImageSearchLoaded) return;
  window.JuneWallImageSearchLoaded = true;

  var searchRoute = window.routes && window.routes.search_url ? window.routes.search_url : '/search';
  var styleWords = [
    ['abstract', ['abstract', 'modern', 'geometric', 'minimal', 'minimalist', 'line', 'boho', 'neutral']],
    ['botanical', ['botanical', 'flower', 'floral', 'plant', 'leaf', 'leaves', 'greenery', 'garden']],
    ['landscape', ['landscape', 'mountain', 'forest', 'lake', 'river', 'desert', 'sunset', 'nature']],
    ['coastal', ['coastal', 'ocean', 'sea', 'beach', 'waves', 'blue', 'water']],
    ['vintage', ['vintage', 'retro', 'classic', 'antique']],
    ['animal', ['animal', 'horse', 'dog', 'cat', 'bird', 'deer']],
    ['city', ['city', 'street', 'architecture', 'building']]
  ];

  function normalizeName(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  }

  function pickStyle(fileName) {
    var text = normalizeName(fileName);
    for (var i = 0; i < styleWords.length; i += 1) {
      for (var j = 0; j < styleWords[i][1].length; j += 1) {
        if (text.indexOf(styleWords[i][1][j]) !== -1) return styleWords[i][0];
      }
    }
    return 'wall art';
  }

  function rgbToHsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;

    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return [h * 360, s, l];
  }

  function colorTerm(r, g, b) {
    var hsl = rgbToHsl(r, g, b);
    var h = hsl[0];
    var s = hsl[1];
    var l = hsl[2];

    if (l < 0.18) return 'black';
    if (l > 0.86 && s < 0.18) return 'white';
    if (s < 0.12) return l > 0.58 ? 'light neutral' : 'gray';
    if (h < 18 || h >= 345) return 'red';
    if (h < 42) return l < 0.45 ? 'brown' : 'warm neutral';
    if (h < 70) return 'gold';
    if (h < 165) return 'green';
    if (h < 250) return 'blue';
    if (h < 310) return 'purple';
    return 'pink';
  }

  function analyzeImage(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function() {
        reject(new Error('read_failed'));
      };
      reader.onload = function() {
        var img = new Image();
        img.onerror = function() {
          reject(new Error('image_failed'));
        };
        img.onload = function() {
          var canvas = document.createElement('canvas');
          var size = 64;
          canvas.width = size;
          canvas.height = size;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, size, size);
          var data = ctx.getImageData(0, 0, size, size).data;
          var r = 0;
          var g = 0;
          var b = 0;
          var count = 0;

          for (var i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 20) continue;
            r += data[i];
            g += data[i + 1];
            b += data[i + 2];
            count += 1;
          }

          if (!count) {
            resolve({ color: 'neutral' });
            return;
          }

          resolve({
            color: colorTerm(Math.round(r / count), Math.round(g / count), Math.round(b / count))
          });
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function buildQuery(file, analysis) {
    var parts = [];
    var color = analysis && analysis.color ? analysis.color : '';
    var style = pickStyle(file.name);

    if (color) parts.push(color);
    if (style && style !== 'wall art') parts.push(style);
    parts.push('wall art');

    return parts.join(' ').replace(/\s+/g, ' ').trim();
  }

  function setStatus(wrapper, message) {
    var status = wrapper.querySelector('.image-search-status');
    if (status) status.textContent = message || '';
  }

  function enhanceForm(form) {
    if (!form || form.dataset.imageSearchReady === 'true') return;
    var searchInput = form.querySelector('input[type="search"][name="q"]');
    if (!searchInput) return;
    form.dataset.imageSearchReady = 'true';

    var submitButton = form.querySelector('button[type="submit"], button[type="Search"], .search-header__submit, .search__button');
    var wrapper = document.createElement('span');
    wrapper.className = 'image-search-control';

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.className = 'image-search-input visually-hidden';
    fileInput.setAttribute('aria-hidden', 'true');
    fileInput.tabIndex = -1;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'image-search-button';
    button.setAttribute('aria-label', 'Search by image');
    button.title = 'Search by image';
    button.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.7l1.2-1.7A1.8 1.8 0 0 1 10.9 3.5h2.2a1.8 1.8 0 0 1 1.5.8L15.8 6h1.7A2.5 2.5 0 0 1 20 8.5v8A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-8Z"/><circle cx="12" cy="12.5" r="3.2"/></svg><span>Image</span>';

    var status = document.createElement('span');
    status.className = 'image-search-status';
    status.setAttribute('aria-live', 'polite');

    wrapper.appendChild(fileInput);
    wrapper.appendChild(button);
    wrapper.appendChild(status);

    if (submitButton && submitButton.parentNode) {
      submitButton.parentNode.insertBefore(wrapper, submitButton);
    } else {
      searchInput.insertAdjacentElement('afterend', wrapper);
    }

    button.addEventListener('click', function() {
      fileInput.click();
    });

    fileInput.addEventListener('change', function() {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type)) {
        setStatus(wrapper, 'Please choose an image.');
        return;
      }

      button.classList.add('is-loading');
      button.disabled = true;
      setStatus(wrapper, 'Finding similar wall art...');

      analyzeImage(file).then(function(analysis) {
        var query = buildQuery(file, analysis);
        searchInput.value = query;
        window.location.href = searchRoute + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
      }).catch(function() {
        setStatus(wrapper, 'Could not read this image. Try another one.');
        button.classList.remove('is-loading');
        button.disabled = false;
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form.search, form.search-header');
    for (var i = 0; i < forms.length; i += 1) enhanceForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
}());
